function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M12.1627132,10.321099 L14,14.0042582 L11.498377,14.0014194 L9.99513102,16 L8,12.0004148 L6.00486898,16 L4.50162299,14.0014194 L2,14.0042582 L3.83728679,10.321099 C4.91617787,11.3606862 6.38342907,12 8,12 C9.61657093,12 11.0838221,11.3606862 12.1627132,10.321099 Z M8,11 C4.96243388,11 2.5,8.53756612 2.5,5.5 C2.5,2.46243388 4.96243388,0 8,0 C11.0375661,0 13.5,2.46243388 13.5,5.5 C13.5,8.53756612 11.0375661,11 8,11 Z M8,10 C10.4852814,10 12.5,7.98528137 12.5,5.5 C12.5,3.01471863 10.4852814,1 8,1 C5.51471863,1 3.5,3.01471863 3.5,5.5 C3.5,7.98528137 5.51471863,10 8,10 Z M8,9 C6.06700338,9 4.5,7.43299662 4.5,5.5 C4.5,3.56700338 6.06700338,2 8,2 C9.93299662,2 11.5,3.56700338 11.5,5.5 C11.5,7.43299662 9.93299662,9 8,9 Z"
});

var SvgRibbon = function SvgRibbon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRibbon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ribbon.fa974c65.svg";
export { ForwardRef as ReactComponent };